"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonDelete = ButtonDelete;
exports.ButtonGroup = ButtonGroup;
exports.ButtonSave = ButtonSave;
exports._stateColor = _stateColor;
exports.default = Button;
var React = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _utils = require("./utils");
var _Form = require("./form/Form");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _btnSize(props) {
  if (props.xs) return 'un-button-xs';
  if (props.sm) return 'un-button-sm';
  if (props.lg) return 'un-button-lg';
  return '';
}
function _stateColor(props) {
  if (props.primary || props.state === 'primary') return 'blue';
  if (props.secondary || props.state === 'secondary') return 'grey-blue';
  if (props.success || props.state === 'success') return 'green';
  if (props.info || props.state === 'info') return 'sky';
  if (props.warning || props.state === 'warning') return 'orange';
  if (props.error || props.state === 'error') return 'red';
  if (props.dark || props.state === 'dark') return 'dark';
  return props.color || 'default';
}
function Button(props) {
  var buttonProps = {
    className: (0, _utils.clsNames)('un-button', 'un-button-' + _stateColor(props) + (props.outline ? '-outline' : ''), _btnSize(props), !props.m0 && 'un-boxmargin', props.fullWidth && '-full-width', props.className)
  };
  var isLink = !!props.href;

  //buttonProps.className += ' btn-' + (props.outline ? 'outline-' : '') + btnState

  if (props.loading) buttonProps.className += ' -loading';
  if (props.loading || props.disabled) {
    buttonProps.className += ' -disabled';
    if (!isLink) buttonProps.disabled = true;
  }
  if (isLink) {
    buttonProps.href = props.href;
    if (props.targetBlank) {
      buttonProps.target = '_blank';
      buttonProps.rel = 'noopener noreferrer';
    }
    if (props.download) {
      buttonProps.download = true;
    }
  } else {
    buttonProps.type = 'button';
  }
  if (props.onClick) {
    if (!props.loading && !props.disabled) {
      buttonProps.onClick = props.onClick;
    }
  }

  // children

  if (!!props.icon || !!props.children || !!props.iconRight) {
    buttonProps.children = /*#__PURE__*/React.createElement(React.Fragment, null, !!props.icon && (typeof props.icon === 'string' ? /*#__PURE__*/React.createElement(_Icon.default, {
      name: props.icon,
      className: '_icon'
    }) : props.icon), !!props.children && (typeof props.children === 'string' ? /*#__PURE__*/React.createElement("span", {
      className: "_text"
    }, props.children) : props.children), !!props.iconRight && (typeof props.iconRight === 'string' ? /*#__PURE__*/React.createElement(_Icon.default, {
      name: props.iconRight,
      className: '_icon'
    }) : props.iconRight));
  }
  var output = /*#__PURE__*/React.createElement(isLink ? 'a' : 'button', buttonProps);
  if (props.form) return /*#__PURE__*/React.createElement(_Form.FormItem, {
    children: output
  });
  return output;
}
function ButtonDelete(props) {
  return /*#__PURE__*/React.createElement(Button, {
    error: true,
    className: 'btn-delete',
    onClick: props.onClick,
    loading: props.loading
  }, "\u0E25\u0E1A");
}
function ButtonSave(props) {
  var _useState = (0, React.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    saving = _useState2[0],
    setSaving = _useState2[1];
  var onSave = function onSave() {
    if (props.onSave) {
      setSaving(true);
      props.onSave(function () {
        setSaving(false);
      });
    }
  };
  var inputProps = {
    sm: props.sm,
    lg: props.lg,
    m0: props.m0,
    className: (0, _utils.clsNames)('un-button-save', props.className)
  };
  var output = /*#__PURE__*/React.createElement(Button, _extends({}, inputProps, {
    state: props.state || 'primary',
    loading: saving,
    onClick: onSave
  }), props.children || 'บันทึก');
  if (props.form) return /*#__PURE__*/React.createElement(_Form.FormItem, {
    children: output
  });
  return output;
}
function ButtonGroup(props) {
  var value = props.value,
    onChange = props.onChange;
  if (!props.items) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-button-group', props.className)
  }, props.items.map(function (b) {
    return /*#__PURE__*/React.createElement(Button, {
      key: 'btn_' + b.id,
      outline: value !== b.id,
      onClick: function onClick() {
        return onChange(b.id, b);
      }
    }, b.name);
  }));
}